var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loader-wrapper"}},[_vm._m(0),_c('div',{attrs:{"id":"label"}},[_c('div',{staticClass:"loader-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"loader-subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"preloader"}},[_c('span'),_c('span'),_c('span'),_c('span'),_c('span')])
}]

export { render, staticRenderFns }